"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getStyles = void 0;

var _react = require("@fluentui/react");

var _BaseButton = require("@fluentui/react/lib/components/Button/BaseButton.styles");

var _ButtonThemes = require("@fluentui/react/lib/components/Button/ButtonThemes");

var _AppBar = require("../AppBar/AppBar.classNames");

var getStyles = (0, _react.memoizeFunction)(function (theme, customStyles, primary) {
  var baseButtonStyles = (0, _BaseButton.getStyles)(theme);
  var appBarButtonStyles = {
    root: {
      display: 'flex',
      flex: '0 0 auto',
      minWidth: _AppBar.APP_BAR_HEIGHT,
      maxWidth: _AppBar.APP_BAR_HEIGHT,
      minHeight: _AppBar.APP_BAR_HEIGHT,
      maxHeight: _AppBar.APP_BAR_HEIGHT,
      alignItems: 'center',
      background: theme.semanticColors.headerButtonsBackground || theme.palette.black,
      color: theme.semanticColors.headerTextIcons,
      selectors: {
        '& .ms-Button-flexContainer > i': {
          fontSize: '20px'
        }
      }
    },
    rootPressed: {
      background: theme.semanticColors.headerButtonsBackgroundHover,
      color: theme.semanticColors.headerTextIcons
    },
    rootHovered: {
      background: theme.semanticColors.headerButtonsBackgroundHover,
      color: theme.semanticColors.headerTextIcons
    },
    rootChecked: {
      background: theme.palette.white,
      color: theme.palette.themePrimary
    },
    rootCheckedHovered: {
      background: theme.palette.white,
      color: theme.palette.themePrimary
    }
  };
  return (0, _react.concatStyleSets)(baseButtonStyles, primary ? (0, _ButtonThemes.primaryStyles)(theme) : (0, _ButtonThemes.standardStyles)(theme), appBarButtonStyles, customStyles);
});
exports.getStyles = getStyles;